/* eslint no-unused-vars: 0 */
import React from 'react';
import { HOC } from 'formsy-react';
import InputElement from 'react-input-mask';

import FormInput from './FormInput';

export default class EditableInput extends FormInput {
    getInputProperties(className) {
        return super.getInputProperties(className);
    }

    render() {
        let className = 'inspectletIgnore ';
        className += this.props.className ? this.props.className : 'app__editable-input';
        const inputProperties = this.getInputProperties(className);

        return <div className={ `${className}` }>
            { this.renderLabel(className) }
            <div className="app__editable-input__container-hint">
                <InputElement {...inputProperties} />
                { this.renderHint() }
            </div>
            { this.renderErrorMessage(className) }
        </div>;
    }
}

EditableInput.propTypes = {
    label: React.PropTypes.string,
    value: React.PropTypes.node,
    type: React.PropTypes.string,
    hintText: React.PropTypes.string,

    maskType: React.PropTypes.string,

    placeholder: React.PropTypes.string,
    name: React.PropTypes.string,
    handleChange: React.PropTypes.func,
    className: React.PropTypes.string,
    widthProportion: React.PropTypes.string,
    fixedWidth: React.PropTypes.string,

    invalidSubmit: React.PropTypes.bool,
};

export const FormEditableInput = HOC(EditableInput);



// WEBPACK FOOTER //
// ./src/components/elements/EditableInput.jsx